import React from "react";
import ReactDOM from "react-dom/client";
import { AlugarVsFinanciar } from "./calculators/alugar-vs-financiar";
import ComparadorRendaFixa from "./calculators/comparador-de-renda-fixa";
import JurosCompostos from "./calculators/juros-compostos";
import { JurosSimples } from "./calculators/juros-simples";
import { ReservaEmergencia } from "./calculators/reserva-emergencia";
import { SimuladorAposentadoria } from "./calculators/simulador-aposentadoria";
import SavingsSelicSimulator from "./calculators/simulador-poupanca-selic";
import "./styles/globals.css";

declare global {
  interface Window {
    WP_Data: {
      is_user_logged_in: boolean;
      user_id: number;
      user_name: string;
    };
  }
}

const calculatorComponents = {
  "compound-interest": JurosCompostos,
  "compare-fixed-income": ComparadorRendaFixa,
  "simulador-poupanca-selic": SavingsSelicSimulator,
  "juros-simples": JurosSimples,
  "reserva-emergencia": ReservaEmergencia,
  "simulador-aposentadoria": SimuladorAposentadoria,
  "alugar-vs-financiar": AlugarVsFinanciar,
} as const;

Object.keys(calculatorComponents).forEach((id) => {
  const element = document.getElementById(id);

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);
    const Component =
      calculatorComponents[id as keyof typeof calculatorComponents];

    /*  root.render(
      <React.StrictMode>
        <JurosSimples />
      </React.StrictMode>
    );

    return; */
    root.render(
      <React.StrictMode>
        <Component />
      </React.StrictMode>
    );
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
